import Text from './FormText'
import Button from './FormButton'
import CheckboxList from './CheckboxList'
import RadioList from './RadioList'
import Actions from './FormActions'
import Select from './Select'

export default {
  Text,
  Button,
  CheckboxList,
  RadioList,
  Actions,
  Select,
}



// WEBPACK FOOTER //
// ./src/components/UI/Form/index.js